module.exports = __webpack_public_path__ + "img/26.f45b86ee.jpg";